import React, {ComponentProps, useEffect, useState} from "react";
import * as api from "../../apis/product";
import {useRequest} from "ahooks";
import {Spin} from "antd";


interface Props extends ComponentProps<any> {
    name: string,
    quality?: string
    base64?: boolean
}

function PictureViewer(props: Props) {
    const {name, quality, base64 = false, ...otherPros} = props
    const [data, setData] = useState<any>()

    const {run, loading} = useRequest(api.getPictureUrl, {
        manual: true,
        defaultParams: [name, quality, base64],
        formatResult: response => setData(response.data.data),
    })

    useEffect(() => {
        run(name, quality, base64).then()
    }, [name, quality, base64])

    if (loading) {
        return <div style={{textAlign: "center", margin: 30}}><Spin spinning/></div>
    }

    return (
        <img src={data} alt="" {...otherPros} />
    )
}

export default PictureViewer
